import { ListFreightTypesService } from 'application/services/list-freight-types'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListFreighttypes = new ListFreightTypesService(api)
